[
  {
    "id": "f31b549f-6583-43d9-8328-0e3a6ea37a49",
    "listingId": "5f7df771-b3a1-4c19-98df-18add4e0690c",
    "playerInstanceId": "96fbf2fd-05de-47eb-aaa7-07fb2ff68386",
    "buyerClubId": "5fde2141-dbbe-501d-859f-ae12674d9a73",
    "terms": {
      "transferAmount": 18000000.00,
      "annualSalary": 5000000.00,
      "releaseClause": 200000000.00,
      "termSeasons": 3
    },
    "submittedAt": "2026-09-28T08:33:15.602725Z",
    "cutoffAt": "2026-09-29T01:00:00Z",
    "reservationExpiresAt": "2026-10-01T01:00:00Z",
    "status": "SUBMITTED",
    "reservationId": "5394ea99-f035-416f-a07e-b7e29bdf9d96",
    "version": 1,
    "player": {
      "playerInstanceId": "96fbf2fd-05de-47eb-aaa7-07fb2ff68386",
      "playerDefinitionId": "66a77156-c10a-52d0-b0f8-9b47603d637b",
      "displayName": "Hugo Novoa",
      "position": "DEFENDER",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0
    }
  },
  {
    "id": "a6de8d8c-0c98-4575-9869-1c66fe4a8c76",
    "listingId": "5f7df771-b3a1-4c19-98df-18add4e0690c",
    "playerInstanceId": "75d7856e-076a-42be-b89a-c631fa0f8d96",
    "buyerClubId": "5fde2141-dbbe-501d-859f-ae12674d9a73",
    "terms": {
      "transferAmount": 6000000.00,
      "annualSalary": 1000000.00,
      "releaseClause": 20000000.00,
      "termSeasons": 3
    },
    "submittedAt": "2026-09-28T07:53:42.601257Z",
    "cutoffAt": "2026-09-29T01:00:00Z",
    "reservationExpiresAt": "2026-10-01T01:00:00Z",
    "status": "SUBMITTED",
    "reservationId": "48b953ae-79e5-4941-b1fc-583bb744468a",
    "version": 1,
    "player": {
      "playerInstanceId": "75d7856e-076a-42be-b89a-c631fa0f8d96",
      "playerDefinitionId": "09dcfd8e-218c-53c4-b9f8-5445469e7884",
      "displayName": "Ademola Lookman",
      "position": "FORWARD",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0
    }
  },
  {
    "id": "d3df32da-a4b4-47fe-9ca2-3768345ec361",
    "listingId": "5f7df771-b3a1-4c19-98df-18add4e0690c",
    "playerInstanceId": "feb7b3b3-b490-4801-9385-c6336264702f",
    "buyerClubId": "5fde2141-dbbe-501d-859f-ae12674d9a73",
    "terms": {
      "transferAmount": 6000000.00,
      "annualSalary": 1000000.00,
      "releaseClause": 20000000.00,
      "termSeasons": 3
    },
    "submittedAt": "2026-09-28T07:48:27.134325Z",
    "cutoffAt": "2026-09-29T01:00:00Z",
    "reservationExpiresAt": "2026-10-01T01:00:00Z",
    "status": "SUBMITTED",
    "reservationId": "0e496a93-f1e2-4bf6-abcc-5dda5e52fdcd",
    "version": 1,
    "player": {
      "playerInstanceId": "feb7b3b3-b490-4801-9385-c6336264702f",
      "playerDefinitionId": "06f482d2-bd7c-514b-b318-2b12d31e1ec6",
      "displayName": "Christantus Uche",
      "position": "FORWARD",
      "type": "REAL",
      "marketValue": 5000000.00,
      "expectedVersion": 0
    }
  }
]
